import moment from 'moment';
import _ from 'lodash';

const helpers = {
    inverterData(data) {
        if (data && data !== '') {
            let dataSplit = [];
            if (data.indexOf('-') !== false) dataSplit = data.split('-');
            else dataSplit = data.split('/');
            return dataSplit[2] + '/' + dataSplit[1] + '/' + dataSplit[0];
        }
        return '';
    },
    formatarDocumento(number) {
        if (!number) return '';
        number = number.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
        if (number.length === 11 && /^\d+$/.test(number)) {
            return number.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        }
        if (number.length === 14) {
            return number.replace(
                /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})/,
                '$1.$2.$3/$4-$5'
            );
        }
        return number;
    },
    formatarTelefone(number) {
        if (!number) return 0;
        number = number.replace(/(\.|\/|-)+/g, '');
        if (number.length === 10) {
            return number.replace(/(\d{2})(\d{4})(\d{4})+/g, '($1) $2-$3');
        } else if (number.length === 11) {
            return number.replace(/(\d{2})(\d{4})(\d{5})+/g, '($1) $2-$3');
        }
        return number;
    },
    formatarCep(number) {
        if (!number) return 0;
        number = number.replace(/(\.|\/|-)+/g, '');
        return number.replace(/(\d{5})(\d{3})+/g, '$1-$2');
    },
    somenteNumeros(string) {
        return typeof string === 'string' ? string.trim().replace(/[^0-9]+/g, '') : string;
    },
    somenteAlfanumericos(string) {
        return typeof string === 'string'
            ? string.trim().replace(/[^a-zA-Z0-9]+/g, '').toUpperCase()
            : string;
    },
    formatarDataHora(dataHora) {
        let dataSplit = [];
        if (dataHora.indexOf('T') !== false) dataSplit = dataHora.split('T');
        else dataSplit = dataHora.split(' ');

        let data = this.inverterData(dataSplit[0]);
        return data + ' ' + dataSplit[1];
    },
    formatarData(dataParam, br = false) {
        if (!dataParam) return null;
        if (dataParam && typeof dataParam === 'string') {
            if (dataParam.indexOf('T') !== -1) {
                let dataSplit = dataParam.split('T');
                dataParam = dataSplit[0];
            }
            if (!br && dataParam.indexOf('-') !== -1) {
                return dataParam;
            }
            if (br) {
                return moment.utc(dataParam, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            return moment.utc(dataParam, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        return dataParam;
    },
    validateEmail(email) {
        if (email == null) return false;
        // Alinhado com o regex do CDT-Pessoa (backend EmailUtil.EMAIL_PATTERN).
        // Manter sincronizado em ambas as pontas.
        const re = /^[_A-Za-z0-9\-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
        return re.test(String(email).trim());
    },
    toUpperCaseField(e, form) {
        const campo = e.target.name;
        const value = e.target.value;
        const maiuscula = value.toUpperCase();
        form.change(campo, maiuscula);
        e.target.value = maiuscula;
    },
    toLowerCaseField(e, form) {
        const campo = e.target.name;
        const value = e.target.value;
        const minusculas = value.toLowerCase();
        form.change(campo, minusculas);
        e.target.value = minusculas;
    },
    validateDate(dateParam) {
        let date = moment.utc(dateParam);
        let valid = date.isValid();
        if (valid) {
            valid = moment.utc(dateParam).isBetween('1900-01-01', '2200-01-01');
        }
        return valid;
    },
    validateCpfCnpj(val) {
        if (!val) return false;
        const doc = val.replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
        function valorCaracterCnpj(caractere) {
            const codigo = caractere.charCodeAt(0);
            if (codigo >= 48 && codigo <= 57) {
                return codigo - 48;
            }
            if (codigo >= 65 && codigo <= 90) {
                return codigo - 48;
            }
            return NaN;
        }
        if (doc.length === 11 && /^\d+$/.test(doc)) {
            let cpf = doc.split('');
            let v1 = 0;
            let v2 = 0;
            let aux = false;
            for (let i = 1; i < cpf.length; i++) {
                if (cpf[i - 1] !== cpf[i]) {
                    aux = true;
                    break;
                }
            }
            if (!aux) {
                return false;
            }
            for (let i = 0, p = 10; i < cpf.length - 2; i++, p--) {
                v1 += parseInt(cpf[i], 10) * p;
            }
            v1 = (v1 * 10) % 11;
            if (v1 === 10) {
                v1 = 0;
            }
            if (v1 !== parseInt(cpf[9], 10)) {
                return false;
            }
            for (let i = 0, p = 11; i < cpf.length - 1; i++, p--) {
                v2 += parseInt(cpf[i], 10) * p;
            }
            v2 = (v2 * 10) % 11;
            if (v2 === 10) {
                v2 = 0;
            }
            return v2 === parseInt(cpf[10], 10);
        }
        if (doc.length === 14) {
            let cnpj = doc.split('');
            let v1 = 0;
            let v2 = 0;
            let aux = false;
            for (let i = 1; i < cnpj.length; i++) {
                if (cnpj[i - 1] !== cnpj[i]) {
                    aux = true;
                    break;
                }
            }
            if (!aux) {
                return false;
            }
            for (let i = 0, p1 = 5, p2 = 13; i < cnpj.length - 2; i++, p1--, p2--) {
                const valor = valorCaracterCnpj(cnpj[i]);
                if (isNaN(valor)) {
                    return false;
                }
                if (p1 >= 2) {
                    v1 += valor * p1;
                } else {
                    v1 += valor * p2;
                }
            }
            v1 = v1 % 11;
            v1 = v1 < 2 ? 0 : 11 - v1;
            if (v1 !== parseInt(cnpj[12], 10)) {
                return false;
            }
            for (let i = 0, p1 = 6, p2 = 14; i < cnpj.length - 1; i++, p1--, p2--) {
                const valor = valorCaracterCnpj(cnpj[i]);
                if (isNaN(valor)) {
                    return false;
                }
                if (p1 >= 2) {
                    v2 += valor * p1;
                } else {
                    v2 += valor * p2;
                }
            }
            v2 = v2 % 11;
            v2 = v2 < 2 ? 0 : 11 - v2;
            return v2 === parseInt(cnpj[13], 10);
        }
        return false;
    },
    removerCaracteresEspeciais(dado) {
        return dado.normalize('NFD').replace(/([\u0300-\u036f]|[^0-9a-zA-Z])/g, '');
    },
    dataURItoBlob(dataURI) {
        let byteString;
        byteString = atob(dataURI.split(',')[1]);
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], { type: mimeString });
    },
    getImage(api, url) {
        return api.get(url, { responseType: 'arraybuffer' }).then((data) => {
            const b64Data = btoa(
                new Uint8Array(data.data).reduce((dataArray, byte) => {
                    return dataArray + String.fromCharCode(byte);
                }, ''),
            );
            const evidenciaData = {
                key: 'evidencia',
                value: `data:image/png;base64,${b64Data}`,
            };
            return evidenciaData.value;
        });
    },
    getFileExtensionFromName(fileName) {
        const temp = fileName.split('.');
        return temp.pop();
    },
    parseQueryString(queryString) {
        if (queryString.startsWith('?')) {
            queryString = queryString.replace('?', '');
        }
        let tempQueryString = [queryString];
        if (queryString.indexOf('&') > 0) {
            tempQueryString = queryString.split('&');
        }
        return tempQueryString.map(() => {
            let temp = queryString.split('=');
            return {
                [temp[0]]: temp[1],
            };
        });
    },
    extractDateFromRevisions(revisions, actualRevision) {
        if (actualRevision && actualRevision.dtVencimentoRevisao) {
            return actualRevision.dtVencimentoRevisao;
        }
        if (revisions && Object.keys(revisions).length > 0) {
            const k = Object.keys(revisions).pop();
            if (revisions[k].dtVencimentoRevisao) return revisions[k].dtVencimentoRevisao;
        }
    },
    ordernarArray({ data, field, direction }) {
        if (!data) return data;
        return _.orderBy(data, [field], [direction ? direction : 'asc']);
    },
};
export default helpers;

export const labelObrigatoriedade = (fieldName, requiredFields) => (requiredFields?.[fieldName] ? '*' : '');
